import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Chat } from "../types";
import { apiClient } from "../services/apiService";
import toast from "react-hot-toast";

interface SearchState {
  suggestions: Chat[];
  loading: boolean;
  isFetched: boolean;
}

const initialState: SearchState = {
  suggestions: [],
  loading: false,
  isFetched: false,
};
export const fetchSuggestions = createAsyncThunk<Chat[], string>(
  "search/fetchSuggestions",
  async (query, { rejectWithValue }) => {
    try {
      const response = await apiClient.get<Chat[]>(`chats/search?title=${query}`);
      return response.data; // Return the full response objects
    } catch (error) {
      toast.error("Error fetching suggestions", {
        className: "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
        duration: 2000,
      });
      return rejectWithValue("Failed to fetch suggestions");
    }
  }
);

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    clearSuggestions: (state) => {
      state.suggestions = [];
      state.isFetched = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuggestions.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSuggestions.fulfilled, (state, action: PayloadAction<Chat[]>) => {
        state.loading = false;
        state.isFetched = true;
        state.suggestions = action.payload;
      })
      .addCase(fetchSuggestions.rejected, (state) => {
        state.loading = false;
        state.isFetched = false;
      });
  },
});

export const { clearSuggestions } = searchSlice.actions;
export default searchSlice.reducer;
